import { io } from "socket.io-client";

const backenUrl = 'https://ntamtech.com'

const Socket = io(backenUrl);

export default Socket;